/**
 * Frontend types for Prompt Versions API
 * Mirrored from backend DTOs (interfaces only, no decorators)
 */

export interface PromptDraftResponse {
  id: string;
  assistantId: string;
  identity: string | null;
  mission: string | null;
  tone: string | null;
  capabilities: string | null;
  responseRules: string | null;
  hasChanges: boolean;
  currentVersion: number | null;
  updatedAt: string;
}

export interface UpdatePromptDraftRequest {
  identity?: string | null;
  mission?: string | null;
  tone?: string | null;
  capabilities?: string | null;
  responseRules?: string | null;
}

export interface PromptVersionResponse {
  id: string;
  assistantId: string;
  versionNumber: number;
  isActive: boolean;
  identity: string | null;
  mission: string | null;
  tone: string | null;
  capabilities: string | null;
  responseRules: string | null;
  publishedAt: string;
  publishedBy: string;
  publisherName?: string;
}

export interface PromptVersionListItem {
  id: string;
  versionNumber: number;
  isActive: boolean;
  publishedAt: string;
  publishedBy: string;
  publisherName: string;
}

export interface PromptVersionsListResponse {
  items: PromptVersionListItem[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface PromptPreviewResponse {
  fullPrompt: string;
  sections: {
    identity: string;
    mission: string;
    tone: string;
    capabilities: string;
    responseRules: string;
    technical: string;
  };
}

// Section names for UI
export type PromptSectionName = 'identity' | 'mission' | 'tone' | 'capabilities' | 'responseRules';

export const PROMPT_SECTION_LABELS: Record<PromptSectionName, string> = {
  identity: 'Identidade',
  mission: 'Missão',
  tone: 'Tom e Diretrizes',
  capabilities: 'Capacidades',
  responseRules: 'Regras de Resposta',
};

export const PROMPT_SECTION_PLACEHOLDERS: Record<PromptSectionName, string> = {
  identity: 'Defina quem é o assistente...',
  mission: 'Qual o objetivo principal do assistente?',
  tone: 'Como o assistente deve se comunicar?',
  capabilities: 'O que o assistente pode e não pode fazer?',
  responseRules: 'Regras específicas para respostas...',
};
